import { createContainer } from '@atlassian/react-sweet-state';
import Store, { type Actions } from '../store.tsx';
import type { State, ContainerProps } from '../types.tsx';

export default createContainer<State, Actions, ContainerProps>(Store, {
	displayName: 'CommentVisibilitiesContainer',
});
